import { authorize, putRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function enableUserAPI(userId) {
  const url = `${AWS_API_URL}/admin/users/${userId}/enable`;

  return putRequest(url, {}, await authorize());
}
